"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectMode = void 0;
var _react = _interopRequireDefault(require("react"));
var _wbmInputs = require("wbm-inputs");
var _RemoveCircleOutline = _interopRequireDefault(require("@material-ui/icons/RemoveCircleOutline"));
var _AddCircleOutline = _interopRequireDefault(require("@material-ui/icons/AddCircleOutline"));
var _selectModeCountMenu = require("../selectModeCountMenu/selectModeCountMenu");
var _headerText = require("../formElements/headerText");
var _cartItem = require("../cartItem/cartItem");
var _InfoOutlined = _interopRequireDefault(require("@material-ui/icons/InfoOutlined"));
var _enums = require("../../constants/enums");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SelectMode = exports.SelectMode = function SelectMode(props) {
  var warning = props.cartItemProps.some(function (cartItem) {
    return cartItem.purchaseProcess === _enums.PurchaseProcess.NavInk || cartItem.availabilityInfo && cartItem.availabilityInfo.doPreventAddToCart == true;
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "select-mode"
  }, /*#__PURE__*/_react["default"].createElement(_wbmInputs.Button, {
    className: 'btn-link medium expand-btn select-mode-button',
    onClick: function onClick() {
      return props.setIsExpanded(!props.isExpanded);
    }
  }, props.isExpanded ? /*#__PURE__*/_react["default"].createElement(_RemoveCircleOutline["default"], null) : /*#__PURE__*/_react["default"].createElement(_AddCircleOutline["default"], null), props.btnText), /*#__PURE__*/_react["default"].createElement("div", {
    className: "select-mode-body"
  }, props.isExpanded && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_headerText.CardHeader, {
    text: props.headerText,
    onLinkClick: props.onLinkClick,
    linkText: props.linkText,
    className: "select-mode-card-header"
  }), warning ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "alert-card select-mode danger"
  }, /*#__PURE__*/_react["default"].createElement(_InfoOutlined["default"], {
    style: {
      marginRight: '5px',
      height: '24px',
      width: '24px',
      alignSelf: "flex-start"
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "message"
  }, "There are some items below that require your attention.")) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cart-item-list-wrapper"
  }, props.cartItemProps.map(function (cartItemVal, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "cart-item-wrapper-select-mode",
      key: "multi-select-" + index
    }, /*#__PURE__*/_react["default"].createElement(_cartItem.CartItem, _extends({}, cartItemVal, {
      customizedUrl: props.customizeUrl ? props.customizeUrl(cartItemVal, props.baseUrl) : "",
      displayListPrice: props.displayListPrice,
      removeMultiSelect: function removeMultiSelect() {
        return props.removeMultiSelect(cartItemVal);
      }
    })));
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "select-mode-menu"
  }, /*#__PURE__*/_react["default"].createElement(_selectModeCountMenu.SelectModeCountMenu, props.selectModeCountMenuProps))));
};
//# sourceMappingURL=selectMode.js.map